export enum LayoutLocations {
	Default,
	RightHandMenu,
	Top,
	Hidden,
	Bottom
}

export const LayoutLocationsLabels = [
	{
		key: LayoutLocations.Default,
		label: "Default",
		details: "Appears in main section"
	},
	{
		key: LayoutLocations.RightHandMenu,
		label: "Right-hand Menu",
		details: "Appears in right-hand section"
	},
	{
		key: LayoutLocations.Top,
		label: "Top",
		details: "Appears in main section, above Attachments"
	},
	{
		key: LayoutLocations.Hidden,
		label: "Hidden",
		details: "Fields are added but not shown"
	},
	{
		key: LayoutLocations.Bottom,
		label: "Bottom",
		details: "Appears in the bottom section, after other fields"
	}
]
